module.exports = __webpack_public_path__ + "img/budd-recovery-position.7d940361.png";